import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/ui/cn";

const headingVariants = cva("font-semibold leading-tight tracking-tight", {
  variants: {
    level: {
      h1: "text-sm mono uppercase tracking-widest text-muted-foreground",
      h2: "text-xl md:text-2xl border-b",
      h3: "text-lg md:text-xl",
      h4: "text-base md:text-lg",
      h5: "text-sm md:text-base",
      h6: "text-xs md:text-sm",
    },
  },
  defaultVariants: {
    level: "h1",
  },
});

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> &
  VariantProps<typeof headingVariants> & {
    asChild?: boolean;
  };

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, level = "h1", asChild, ...props }, ref) => {
    const Comp = asChild ? Slot : (level ?? "h1");
    return <Comp ref={ref} className={cn(headingVariants({ level, className }))} {...props} />;
  }
);
Heading.displayName = "Heading";

export { Heading };
